module.exports = __webpack_public_path__ + "img/back.dee0b219.png";